import { render, staticRenderFns } from "./TaskTree.vue?vue&type=template&id=33909aa2&scoped=true"
import script from "./TaskTree.vue?vue&type=script&lang=js"
export * from "./TaskTree.vue?vue&type=script&lang=js"
import style0 from "./TaskTree.vue?vue&type=style&index=0&id=33909aa2&prod&scoped=true&lang=css"
import style1 from "./TaskTree.vue?vue&type=style&index=1&id=33909aa2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33909aa2",
  null
  
)

export default component.exports